
import { CardContent } from '@/components/ui/card';
import { SocialPlatform } from '../profiles/types';
import PlatformsSection from './PlatformsSection';
import { socialPlatforms, adPlatforms } from './platformsData';

interface AddProfileContentProps {
  onSelectPlatform: (platform: SocialPlatform) => void;
}

const AddProfileContent = ({ onSelectPlatform }: AddProfileContentProps) => {
  return (
    <CardContent className="p-6">
      <PlatformsSection 
        title="Profils sociaux" 
        platforms={socialPlatforms} 
        onSelectPlatform={onSelectPlatform} 
      />
      
      <PlatformsSection 
        title="Comptes de publicité" 
        platforms={adPlatforms} 
        onSelectPlatform={onSelectPlatform} 
        isNew 
      />
    </CardContent>
  );
};

export default AddProfileContent;
